import NotificationModal from '@anm/components/modals/NotificationModal';
import { FC } from 'react';

import { useSuccessNotification } from './hooks';

const SuccessNotification: FC = () => {
  const [
    isOpenNotification,
    handleCloseNotification,
    notificationPosition
  ] = useSuccessNotification();

  if (!isOpenNotification) return null;

  return (
    <NotificationModal
      timeout={2000}
      type="success"
      variant="custom"
      position={notificationPosition}
      onModalClose={handleCloseNotification}
    />
  );
};

export default SuccessNotification;
